<script>
import { layoutMethods, gbitsMethods } from "@/state/helpers";

import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Gbits Invitation",
  },
  data() {
    return {
      email: null,
      invitationLink: null,
      sendBtnText: "Send Signup Email",
      showSuccess: false,
      isExisting: false,
    };
  },
  computed: {
    disabledButton() {
      return this.invitationLink ? false : true;
    },
  },
  async mounted() {
    this.changeTitle({ title: "GBITS Account Creation" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "GBITS Manager", to: { name: "" } },
        { text: "GBITS Account Creation", to: { name: "" } },
      ],
    });
  },
  methods: {
    ...layoutMethods,
    ...gbitsMethods,
    generateInviteLink() {
      if (!this.email) {
        return;
      }

      var generateLinkParams = {
        email: this.email,
      };

      this.actionGbitsInvitation({
        action: "generate-invitation",
        body: generateLinkParams,
      })
        .then((res) => {
          if (res.status == "ok") {
            this.invitationLink = res?.message?.inviteLink;
            this.showSuccess = true;
            this.isExisting = res?.message?.isExisting;

            if (res?.message?.emailStatus) {
              this.sendBtnText = "Re-Send Signup Email";
            } else {
              this.sendBtnText = "Send Signup Email";
            }
          } else {
            console.log("error");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async copyLink() {
      await navigator.clipboard.writeText(this.invitationLink);
      this.$toastV2.success(
        "Signup link copied to clipboard!",
        3000,
        "bottom-right"
      );
    },
    sendEmail() {
      if (!this.invitationLink) {
        return;
      }

      var sendEmailParams = {
        email: this.email,
      };

      this.actionGbitsInvitation({
        action: "send-invite-email",
        body: sendEmailParams,
      })
        .then((res) => {
          if (res.status == "ok") {
            console.log(res);
          } else {
            console.log("error");
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          Swal.fire({
            title: "Email Sent Successfully",
            text: `The account creation link has been successfully sent to ${this.email}.`,
            icon: "success",
          });
        });
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-6">
      <div class="card">
        <div class="card-body">
          <ValidationObserver v-slot="{ handleSubmit, reset }">
            <b-form
              @submit.prevent="handleSubmit(generateInviteLink)"
              @@reset.prevent="reset"
            >
              <b-row>
                <b-col sm="12" class="mb-3">
                  <label class="form-label small fw-bold"
                    >Email Address<span class="text-danger">*</span></label
                  >
                  <validation-provider
                    name="email-address"
                    rules="required"
                    v-slot="{ errors, ariaMsg }"
                  >
                    <b-form-input
                      type="email"
                      class="form-control"
                      v-model="email"
                      placeholder="Enter email address"
                      :class="{
                        'is-invalid': errors[0],
                      }"
                    />
                    <b-form-invalid-feedback v-bind="ariaMsg">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="12" class="mb-3 d-flex justify-content-end">
                  <button class="btn btn-primary" type="submit">Generate Link</button>
                </b-col>
              </b-row>
            </b-form>
          </ValidationObserver>

          <hr />

          <b-row class="mb-4">
            <b-col sm="12" class="d-flex">
              <div class="me-3"><strong>Details: </strong></div>
              <div class="generate-success" v-if="showSuccess && !isExisting">
                <i class="fa fa-check-circle"></i> Successfully Link Generated
              </div>
              <div class="generate-success" v-if="showSuccess && isExisting">
                <i class="fa fa-check-circle"></i> A link already exists. It has
                been regenerated.
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12" class="mb-3">
              <label class="form-label small fw-bold">Sign Up Link:</label>
              <b-form-input
                type="text"
                class="form-control"
                v-model="invitationLink"
                placeholder="--"
                :disabled="true"
              />
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12" class="mb-3">
              <button
                class="btn btn-primary me-2"
                @click="copyLink"
                :disabled="disabledButton"
              >
                <i class="bx bx-copy"></i> Copy
              </button>
              <button
                class="btn btn-primary"
                @click="sendEmail"
                :disabled="disabledButton"
              >
                <i class="bx bx-envelope"></i> {{ sendBtnText }}
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.generate-success {
  color: var(--success-colors-success-base-500, #508f30);
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 30px */
}
</style>
